// Test IDs for the Admin Messages tab (contact form inbox + Jev triage).

export const ADMIN_MESSAGES = {
  root: 'admin-messages-table',
  category: (id) => `admin-message-category-${id}`,
  urgentFilterToggle: 'admin-messages-urgent-filter-toggle',
  urgentCount: 'admin-messages-urgent-count',
  empty: 'admin-messages-empty',
  row: (id) => `admin-message-row-${id}`,
};
